/* Hide the Stamped reviews section on a product that has no reviews.

   Why this is not Liquid
   ----------------------
   Stamped does not sync a review count into product metafields on this store
   -- the reviews namespace is empty even on a product showing 4.8 stars -- so
   there is nothing for the section to branch on at render time. The count only
   exists once Stamped's own script has answered:

     #stamped-main-widget > .stamped-container[data-count]

   Verified live: 23 on serpentina-snake-choker, 0 on leopard-stripe-scarf.

   The widget starts hidden in the stylesheet, which loads only on the 2026
   product section, so this is scoped to that template and the older ones that
   share the Stamped section are untouched. Starting hidden rather than hiding
   afterwards is what keeps an empty reviews block from appearing and then
   collapsing under the shopper. */
(function () {
  if (window.EttikaStampedEmpty) return;

  var RESOLVED = 'ettika-stamped--resolved';
  /* Fail open: if Stamped never runs at all -- blocked, or failing to load --
     revealing an empty widget is a smaller fault than silently removing the
     reviews of every product on the site. */
  var GIVE_UP_MS = 10000;

  function widget() {
    return document.getElementById('stamped-main-widget');
  }

  function reveal() {
    var el = widget();
    if (el) el.classList.add(RESOLVED);
  }

  /* Returns true once the answer is known, either way. */
  function settle() {
    var el = widget();
    if (!el) return false;

    var container = el.querySelector('.stamped-container[data-count]');
    if (!container) return false;

    var count = parseInt(container.getAttribute('data-count'), 10);
    if (isNaN(count)) return false;

    if (count > 0) reveal();
    else el.classList.remove(RESOLVED);
    return true;
  }

  function start() {
    if (settle()) return;

    /* Stamped renders the container late and rewrites data-count when its
       fetch returns, so watch for both rather than racing either. */
    var observer = new MutationObserver(function () {
      settle();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-count'],
    });

    setTimeout(function () {
      observer.disconnect();
      /* Only give up on a widget Stamped never touched. One it did touch has
         already been settled, and settling again here would undo it. */
      if (!settle()) reveal();
    }, GIVE_UP_MS);
  }

  window.EttikaStampedEmpty = { settle: settle };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
